var userConfigEdit = {
  data() {
    return {
      _userConfigCambio: false
    };
  },
  computed: {
    userConfig() {
      return this.$store.getters["user/config"];
    },
    ucMddTam: {
      get() {
        return this.userConfig.mdd.tam;
      },
      set(v) {
        this._userConfigCambio = true;

        let payload = {
          id: this.userConfig.id,
          data: { mdd: { tam: v } },
          prop1: "mdd",
          prop2: "tam",
          level: 2,
          value: v
        };
        this.$store.commit("user/updateConfig", payload);
      }
    }
  }
};

export default userConfigEdit;
